import { createAction, props } from '@ngrx/store';
import { List } from '@epicuro-next/models/engagement';

export const cloneProductList = createAction(
  '[ProductList] Clone List',
  props<{ list: Partial<List> }>(),
);

export const cloneProductListSuccess = createAction(
  '[ProductList] Clone List Success',
  props<{ list: Partial<List> & Pick<List, 'id'> }>(),
);

export const cloneProductListFailed = createAction(
  '[ProductList] Clone List Failed',
  props<{ error: string }>(),
);
